<template>
  <div style="width: 100%">
    <mx-panel v-if="!IsDelete && value" :type="config.Type" :value="value" :config="Config" panel="SystemList2" :selected="selected" :index="index" @event="OnEvent">
      <template>
        <div class="flex-row" style="width: 100%">
          <div class="w200 left" style="color: #878a99">所属题库</div>
          <div class="wf left" style="color: #878a99">名称</div>

          <div class="w100 left" style="color: #878a99">题型</div>
          <div class="w200 left" style="color: #878a99">创建时间</div>
          <div class="w300 left" style="color: #878a99">操作</div>
        </div>
      </template>
      <template slot="content">
        <div class="" style="width: 100%; position: relative">
          <div class="flex-row start middle border-bottom" style="width: 100%; padding: 20px 0">
            <div class="w200 flex-row start list pointer left">
              {{ value.Parent.Name }}
            </div>
            <div class="wf flex-row start list active pointer left" @click="onShowMore">
              <i :class="show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              {{ value.Title || value.Name }}
            </div>
            <div class="w100 flex-row start list">
              <mx-field :value="value" :config="ModuleTypeField" :type="ModuleTypeField.Type" :name="ModuleTypeField.Name" v-if="ModuleTypeField"> </mx-field>
            </div>
            <div class="w200 flex-row start list">
              {{ value.CreateTime }}
            </div>
            <div class="w300 flex-row start list">
              <div class="pointer active" @click="onGoDetail" v-if="IsDetail">详情</div>
              <div v-if="!GetDisabled('modify')">
                <a class="active" href="javascript:void(0)" @click="OnModify">编辑</a>
              </div>
              <div v-if="!GetDisabled('del')">
                <a class="active" href="javascript:void(0)" @click="OnDelete">删除</a>
              </div>
            </div>
          </div>
          <div class="panel3 p1 flex-row top p1" style="" v-if="show">
            <div class="wf flex-column p1">
              <div class="flex-row start wf p1" v-for="(item, index) in Options" :key="index">
                <div>{{ item.option }}:</div>
                <div>
                  {{ item.value }}
                </div>
              </div>
            </div>
            <div class="wf flex-column start p1">
              <div class="flex-row start wf left p1">
                <div class="f16g left flex-row" style="width: 200px">正确答案</div>
                <div class="wf flex-row start left">{{ value.Answer }}</div>
              </div>
              <div class="flex-row start wf p1 left">
                <div class="f16g left flex-row" style="width: 200px">解析</div>
                <div class="wf flex-row start left" v-html="Contents"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div slot="button"></div>
    </mx-panel>
  </div>
</template>

<script>
import base from 'matrix.node.ui/libs/panels/base.js'
export default {
  props: {
    config: Object,
    value: Object,
    index: Number,
    role: String,
    roleField: String,
    name: String,
    selected: Object
  },
  mixins: [base],
  data() {
    return { IsModify: false, IsDelete: false, show: false }
  },
  computed: {
    SiteUrl() {
      return this.$matrix.Config.ImageSite
    },
    Config() {
      return Object.assign({ EventName: this.name ? this.name : 'TypeEvent', IsDark: false }, this.config)
    },
    ModuleTypeField() {
      return this.$matrix.Models[this.config.Type].Fields.find((val) => {
        return val.Name === 'ModuleType'
      })
    },
    IsDetail() {
      if (this.config.DetailView) return true
      return false
    },
    Options() {
      let letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let option = Object.keys(this.value).filter((f) => {
        return f.indexOf('Options') > -1
      })
      let res = option
        .map((o, index) => {
          if (this.value[o]) {
            return { Title: letter[index], value: this.value[o] }
          }
        })
        .filter(Boolean)

      if (res.length)
        return res.map((r) => {
          return {
            option: r.Title,
            value: r.value
          }
        })
      return res
    },
    Contents() {
      return this.value.Contents.replace(/<[^>]*>/g, '')
    }
  },
  methods: {
    OnEvent(e) {
      this.$emit('event', e)
    },
    onGoDetail() {
      let View = this.config.DetailView
      if (!View) return this.$matrix.ShowError('未配置详情视图')
      this.$emit('goview', {
        View: View,
        ViewType: '详情',
        Data: this.value,
        Role: this.config.Role,
        RoleField: this.config.RoleField
      })
    },
    onShowMore() {
      this.show = !this.show
    }
  }
}
</script>

<style scoped>
.wf {
  flex: 1;
}

.wf2 {
  flex: 2;
}

.border {
  border: 1px solid #eee;
}

.label_1,
.label_2,
.label_3 {
  border-radius: 4px;
  padding: 4px 6px;
  text-align: center;
}

.label_1 {
  background: #fbc451;

  color: #fff;
}

.label_2 {
  background: #a498cb;

  color: #fff;
}

.label_3 {
  background: #a7bba9;

  color: #fff;
}

.label_4 {
  background: #f49a71;

  color: #fff;
}

.label_5 {
  background: #6d72bb;

  color: #fff;
}

.active {
  color: #2d8cf0;
}

.text-line {
  text-decoration: line-through;
  color: gray;
}

span.button {
  color: #2d8cf0;
  cursor: pointer;
}

.image-box {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  opacity: 1;
  background-color: rgba(243, 246, 249, 1);
  padding: 4px;
}

.border-bottom {
  border-bottom: 1px solid #e9ebec;
}
</style>
